import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Required = styled.span`
  margin: 0.3125rem 0 1rem auto;
  font-family: ${themeGet('textFontFamilySemibold')};
`
export const Header = styled.h2`
  color: #000000;
  font-family: 'Molde-Semibold';
  font-size: 21px;
  letter-spacing: 0.75px;
  line-height: 25px;
  margin-bottom: 1.25rem;
  margin-top: 0.125rem;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8125rem;
`

export const ErrorContainer = styled.span`
  color: ${themeGet('colors.textDanger')};
  font-family: ${themeGet('textFontFamily')};
  line-height: 20px;
  letter-spacing: normal;
  margin-left: 0.8125rem;
`
export const StyledHr = styled.hr`
  border-top: 1px solid ${themeGet('colors.gray200')};
  width: 100%;
`
export const SchoolLookUpContainer = styled.div`
  margin-bottom: 40px;
  label {
    color: ${themeGet('colors.darkGray')};
    font-size: 1rem;
    font-family: ${themeGet('textFontFamilySemibold')};
    margin-bottom: 6px;

    :first-child {
      margin-bottom: 3px;
    }
  }
  .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 9px;

    :last-child {
      margin-bottom: 0;
    }
    select {
      height: 38px;
      letter-spacing: 0.57px;
      line-height: 19px;
      color: ${themeGet('colors.black')};
      border: 1px solid ${themeGet('colors.gray1000')};
      padding-bottom: 7px;
    }
    label {
      font-weight: 400;
    }
  }
`

interface SubmitSectionProps {
  isFirstTimeUser?: boolean
}

export const SubmitSection = styled.div<SubmitSectionProps>`
  border-top: 1px solid ${themeGet('colors.gray200')};
  width: 100%;
  display: flex;
  justify-content: ${({ isFirstTimeUser }) =>
    isFirstTimeUser ? 'center' : 'flex-end'};
  padding: 40px 0px;
`
export const SubmitButton = styled.button`
  border: none;
  border-radius: 5px;
  width: 215px;
  height: 43px;
  color: ${themeGet('colors.white')};
  background-color: ${themeGet('colors.blue')};
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  -moz-transition: background 0.2s ease-in;
  -o-transition: background 0.2s ease-in;
  -webkit-transition: background 0.2s ease-in;
  transition: background 0.2s ease-in;
  :disabled {
    color: ${themeGet('colors.mediumGray')};
    background-color: ${themeGet('colors.buttonDisabled100')};
  }
  :enabled:hover {
    ${themeGet('colors.white')};
    background-color: ${themeGet('colors.darkBlue')};
  }
`
